import React, { useEffect, useState } from "react";
import { Collapse, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchReplysThunk } from "../../../Slices/Thunk/notification";
import { setRepliesForEmail } from "../../../Slices/emailRepliesSlice";
import EmailThread from "../Sales1/EmailThread";

const { Panel } = Collapse;

export const EmailTrackMails = ({ emailRows }) => {
  const dispatch = useDispatch();
  const repliesMap = useSelector((state) => state.emailReplies.repliesByEmailId);
  const [loadingKey, setLoadingKey] = useState(null);

  const fetchReplies = async (messageId, email) => {
    if (!messageId || !email) {
      message.warning("Missing messageId or email");
      return;
    }

    setLoadingKey(messageId);

    try {
      const res = await dispatch(FetchReplysThunk({ email, messageId })).unwrap();
      const replies = res?.replies || [];

      dispatch(setRepliesForEmail({ emailID: messageId, replies }));

      if (!replies.length) {
        message.info("No replies found");
      }
    } catch (err) {
      console.error("Error fetching replies:", err);
      message.error("Failed to fetch replies");
    } finally {
      setLoadingKey(null);
    }
  };

  const handleExpand = async (messageId, email) => {
    console.log("Panel expanded:", messageId, email);
    await fetchReplies(messageId, email);
  };

  return (
    <Collapse
      accordion
      onChange={(key) => {
        // Handle both string and array types from Collapse
        const activeKey = Array?.isArray(key) ? key[0] : key;
        if (!activeKey) return;

        // Find the matching email row
        const row = emailRows?.find(
          (item) => String(item.messageId) === String(activeKey)
        );

        if (row) {
          handleExpand(row.messageId, row.email);
         
        }
      }}
    >
      {emailRows?.map((row) => (
        <Panel
          header={`${row.email} → ${row.messageId}`}
          key={row.messageId}
        >
          {loadingKey === row.messageId ? (
            "Loading replies..."
          ) : (
            <EmailThread
              replies={repliesMap[row.messageId] || []}
              EmailList={[row.mail]}
            />
          )}
        </Panel>
      ))}
    </Collapse>
  );
};
